<div class="page-container content-w-98">
  <div class="page-head">
    <div>
      <div class="page-title">
        <p class="headerName">{{ headerData.materialName }}</p>
      </div>
    </div>
  </div>
  <div [ngClass]="{ 'disabled-project': isScreenDisabled }">
    <div class="" [ngClass]="{ 'disabled-project': checkboxValue }">
      <div
        class="col-md-12"
        *ngrxLet="{
          dataLoaded: (sharedFacade.isLoaded$ | async),
          isClearSearch: (sharedFacade.isClearSearch$ | async)
        } as sharedData"
      >
        <piqet-angular-portlet
          *ngIf="sharedData.dataLoaded"
          [class]="'detail-cell-renderer'"
          [columnDefs]="columnDefs"
          [frameworkComponents]="frameworkComponents"
          [headerBtn]="retailList?.retailList.length >= 1 ? '' : 'Add retail'"
          [searchInputSize]="true"
          [gridData]="retailList?.retailList"
          [class]="'fixedHeight'"
          [hidePagination]="true"
          [hideSearch]="true"
          [pageNo]="$any(retailList?.retailList)?.draw"
          [createAccess]="showEdit"
          (openBtnModal)="addCustomRetail(scenarioId, 0, 2, 'Add retail')"
          [gridName]="'Retail list'"
          [hideSideBar]="isHideSideBar"
          [isClearSearch]="sharedData.isClearSearch"
        ></piqet-angular-portlet>
      </div>
    </div>
  </div>
  <piqet-angular-navigation-button [config]="navigationConfig"> </piqet-angular-navigation-button>
</div>
